<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Proveedores</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link class="btn btn-sm btn-success" :to="{ name: 'cat-proveedores-nuevo', params: {} }">
                <i class="fa fa-plus"></i>
                Nuevo Proveedor
              </router-link>
              <a class href="#"></a>
              <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
            </div>
            <div class="col-sm-6">
              <form @submit="filterData" action="#" class="form-inline justify-content-sm-end">
                <input class="form-control form-control-sm rounded bright" placeholder="Search" v-model="searchtext"
                  type="text" />
                <select class="form-control form-control-sm rounded bright" v-model="filterActivo" @click="filterData">
                  <option selected value="null">Todos</option>
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Perfil</th>
                <th>Código</th>
                <th>Nombre</th>
                <th class="text-center">Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="rowClick(current)">
                <td>
                  <img :src="current.image" :alt="'Imagen proveedor' + current.codigo" width="25px" />
                </td>
                <td>{{ current.codigo }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div v-if="current.activo" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                  <div v-if="!current.activo" class="status-pill red" data-title="Inactivo" data-toggle="tooltip"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProveedorService from "@/services/catalogos/ProveedorService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      filterActivo: null,
      searchtext: "",
      data: [],
    };
  },
  mounted() {
    this.refreshData({
      "filter[search]": this.searchtext,
      activo: this.filterActivo,
    });
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-proveedores-editar",
          params: { id: current.codigo },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-proveedores-editar",
          params: { id: current.codigo },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    clearFilterData() {
      this.filterActivo = null;
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() { },
    refreshData(params) {
      let self = this;
      ProveedorService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() { },
  },
};
</script>
